import React, { Fragment, ReactElement } from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Typography,
  Chip,
  Paper,
  Divider,
} from '@material-ui/core';
import * as AdminDashboardSelectors from '../../../../redux/reducers/admin_dashboard_reducer/selectors';
import useStyles from './styles';
import PermScanWifiIcon from '@material-ui/icons/PermScanWifi';
import LinearProgress from '@material-ui/core/LinearProgress';
import PropTypes from 'prop-types';
import ErrorIcon from '@material-ui/icons/Error';
import ActiveRegistrationsIcon from '@material-ui/icons/HowToReg';
import ExcludedRegistrationIcon from '@material-ui/icons/PersonAddDisabled';
import VerifiedUserIcon from '@material-ui/icons/PersonAdd';
import PendingApprovalUserIcon from '@material-ui/icons/Person';
import HourglassTopIcon from '@material-ui/icons/Timer';

interface IContent {
  name: string;
  value: string;
}

interface IProps {
  title: string;
  content: IContent[];
}
export default function KPI(props: IProps) {
  const classes = useStyles();

  let registrationStatus: string | undefined = 'Active';

  if (props.title == 'Status')
    registrationStatus = props.content.find(
      (item) => item.name === 'Registration Status'
    )?.value;

  if (!registrationStatus) registrationStatus = 'Excluded';

  const chipColor =
    registrationStatus === 'Active'
      ? 'green'
      : registrationStatus === 'Excluded'
      ? 'red'
      : registrationStatus === 'Pending Submission'
      ? 'orange'
      : registrationStatus === 'Pending Approval'
      ? 'blue'
      : 'black';

  return (
    <>
      <Card className={classes.root}>
        <CardContent>
          <Grid container spacing={0}>
            <Grid item xs={9}>
              <Typography
                className={classes.title}
                color="textSecondary"
                gutterBottom
              >
                {props.title}
              </Typography>
            </Grid>
            <Grid item xs={3} style={{ textAlign: 'right' }}>
              {props.title == 'Information' && (
                <ErrorIcon fontSize="large" className={classes.blueIcon} />
              )}
              {props.title == 'Status' && registrationStatus == 'Active' && (
                <ActiveRegistrationsIcon
                  fontSize="large"
                  className={classes.greenIcon}
                />
              )}

              {props.title == 'Status' && registrationStatus == 'Excluded' && (
                <ExcludedRegistrationIcon
                  fontSize="large"
                  className={classes.redIcon}
                />
              )}

              {props.title == 'Status' &&
                registrationStatus == 'Pending Submission' && (
                  <VerifiedUserIcon
                    fontSize="large"
                    className={classes.orangeIcon}
                  />
                )}

              {props.title == 'Status' &&
                registrationStatus == 'Pending Approval' && (
                  <PendingApprovalUserIcon
                    fontSize="large"
                    className={classes.blueIcon}
                  />
                )}
              {props.title.includes('Deadline') && (
                <HourglassTopIcon
                  fontSize="large"
                  className={classes.redIcon}
                />
              )}
            </Grid>
          </Grid>
          <Grid container spacing={0}>
            {props.title != 'Status' &&
              !props.title.includes('Deadline') &&
              props.content.map((item, index) => (
                <React.Fragment key={index}>
                  <Grid item xs={12}>
                    <Typography className={classes.contents}>
                      {item.name} : <strong>{item.value}</strong>
                    </Typography>
                  </Grid>
                </React.Fragment>
              ))}

            {props.title === 'Status' && (
              <Box height={'67px'} alignContent={'center'}>
                <Chip
                  label={registrationStatus}
                  className={classes.chip}
                  style={{
                    backgroundColor:
                      chipColor == 'blue' ? '#42a5f5' : chipColor,
                  }}
                />
              </Box>
            )}

            {props.title.includes('Deadline') && (
              <Box height={'70px'} alignContent={'center'}>
                <TimerComponent
                  days={
                    props.content[0]
                      ? props.content[0].value.split(':')[0]
                      : '00'
                  }
                  hours={
                    props.content[0]
                      ? props.content[0].value.split(':')[1]
                      : '00'
                  }
                  minutes={
                    props.content[0]
                      ? props.content[0].value.split(':')[2]
                      : '00'
                  }
                  seconds={
                    props.content[0]
                      ? props.content[0].value.split(':')[3]
                      : '00'
                  }
                />
              </Box>
            )}
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}
interface TimerProps {
  days: string;
  hours: string;
  minutes: string;
  seconds: string;
}

function TimerComponent({ days, hours, minutes, seconds }: TimerProps) {
  const timerStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
  };

  const valueStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };

  const labelStyle: React.CSSProperties = {
    fontSize: '14px',
    textTransform: 'lowercase',
  };

  const digitStyle: React.CSSProperties = {
    fontSize: '30px',
  };
  return (
    <div style={timerStyle}>
      <div style={valueStyle}>
        <Typography variant="h5" component="span" style={digitStyle}>
          {days}
        </Typography>
        <Typography variant="body2" component="span" style={labelStyle}>
          Days
        </Typography>
      </div>
      <div style={valueStyle}>
        <Typography variant="h5" component="span" style={digitStyle}>
          {hours}
        </Typography>
        <Typography variant="body2" component="span" style={labelStyle}>
          Hours
        </Typography>
      </div>
      <div style={valueStyle}>
        <Typography variant="h5" component="span" style={digitStyle}>
          {minutes}
        </Typography>
        <Typography variant="body2" component="span" style={labelStyle}>
          Minutes
        </Typography>
      </div>
      <div style={valueStyle}>
        <Typography variant="h5" component="span" style={digitStyle}>
          {seconds}
        </Typography>
        <Typography variant="body2" component="span" style={labelStyle}>
          Seconds
        </Typography>
      </div>
    </div>
  );
}
